import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock/data";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#090c09]/90 backdrop-blur-md border-b border-white/[0.06]" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-[1300px] mx-auto px-5 md:px-8 h-[68px] flex items-center justify-between">
        <a href="#top" className="flex flex-col justify-center select-none leading-none">
          <span className="display text-[17px] tracking-tight flex items-center gap-1.5">
            COPYX <span className="text-accent text-[13px] font-normal mono">×</span> SONIC AI
          </span>
          <span className="label text-accent text-[0.55rem] mt-1">Canada</span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="label text-[var(--muted)] hover:text-[var(--text)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="#join" className="hidden sm:inline-flex btn-accent px-5 py-2.5 rounded-lg">
            Join the community
          </a>
          <button
            className="lg:hidden text-[var(--text)]"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#090c09] border-t border-white/[0.06] px-5 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="label text-[var(--muted)] hover:text-[var(--text)] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="#join" onClick={() => setOpen(false)} className="btn-accent px-5 py-3 rounded-lg text-center mt-1">
            Join the community
          </a>
        </div>
      )}
    </header>
  );
}
